module.exports = __webpack_public_path__ + "static/img/ls8.1e80dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls8.png
// module id = m2WO
// module chunks = 12